import React, {Component} from 'react'
import Button from 'material-ui/Button'
import Menu, {MenuItem} from 'material-ui/Menu'
import PropTypes from 'prop-types'


class WordsMenu extends Component {
    state = {
        anchorEl: undefined,
        open: false
    };

    onClickButton = e => {
        this.setState({open: true, anchorEl: e.currentTarget});
    };

    onclickItem = e => {
        this.setState({open: false});
        this.props.word(e.currentTarget.innerText);
    };
    requestClose = () => {
        this.setState({open: false});
    };

    render() {

        if (this.props.menuItems.length === 0) {
            return null
        }

        return (

            <div>
                <Button aria-owns="simple-menu" aria-haspopup="true" onClick={this.onClickButton}>
                    {this.props.menuName}
                </Button>
                <Menu id="simple-menu"
                      anchorEl={this.state.anchorEl}
                      open={this.state.open}
                      onRequestClose={this.requestClose}>

                    {this.props.menuItems.map((item, index) => (
                            <MenuItem onClick={this.onclickItem} key={index}>{item}</MenuItem>
                        )
                    )}
                </Menu>
            </div>

        )
    }

}

WordsMenu.propTypes = {
    menuName: PropTypes.string.isRequired,
    menuItems: PropTypes.array.isRequired,
};


export default WordsMenu;



// WEBPACK FOOTER //
// ./src/words-menu.jsx